import React from "react";
import "./.././styles/loader_styles/Loader.css"; // You'll add styling here

interface LoadingProps {
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner">
        <div className="spinner"></div>
        <p className="loading-text">{message ?? "Loading..."}</p>
      </div>
    </div>
  );
};

export default Loading;
